import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { Contact } from '../models/contact.model';
import { getContactInfo } from '../requests/contactInfo.request';

export function useContactInfo(partnerId: string) {
  const [contact, setContact] = useState<Contact | null>(null);

  const { request: _, status } = useRequest(
    async () => {
      if (!partnerId) {
        return;
      }
      setContact(await getContactInfo(partnerId));
    },
    { requestOnMount: true }
  );

  return { contact, isFetchContactInfoSettled: status.isError || status.isSuccess };
}
